<template>
  <div class="content_title">
    <div>
      <label style="color: #606266; font-size: 14px">Custom Column Set</label>
      <el-button type="mini" @click="addColumn">Add Column Condition</el-button>
      <div style="margin-top: 10px">
        <div style="display: flex">
          <label style="width: 166px">Column Name</label>
          <label style="width: 166px">Parent Column</label>
          <label style="width: 163px">Category</label>
          <label style="width: 166px">Required</label>
          <label style="width: 160px">Content</label>
        </div>
        <div
          v-for="(column, index) in columns"
          :key="index"
          :div_id="column.id"
        >
          <el-input
            class="input-filter"
            v-model="column.columnname"
            placeholder="Please input"
            maxlength="100"
            style="width: 150px"
          ></el-input>
          <el-select
            v-model="column.parentcolumn"
            clearable
            placeholder="Please Choose"
            style="margin-left: 10px; width: 150px"
            :disabled="column.disabled"
            @click.native="getParents(column.id)"
            @change="parentChange(column.id)"
          >
            <el-option
              v-for="item in parents"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="column.columncate"
            clearable
            placeholder="Please Choose"
            style="margin-left: 10px; width: 150px"
            @change="disclick(column.id, column.columncate)"
          >
            <el-option
              v-for="item in cates"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="column.columnrequired"
            clearable
            placeholder="Please Choose"
            style="margin-left: 10px; width: 150px"
          >
            <el-option
              v-for="item in isrequired"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-input
            v-if="!column.isparent"
            class="input-filter"
            v-model="column.columncontent"
            placeholder="Please input"
            maxlength="100"
            style="width: 460px; margin-left: 10px"
            :disabled="column.disabled"
            @change="Replace(column.id, column.columncontent)"
          ></el-input>
          <el-input
            class="input-filter"
            v-if="column.isparent"
            type="textarea"
            rows="3"
            v-model="column.columncontent"
            placeholder="Please input"
            maxlength="100"
            style="width: 460px; margin-left: 10px"
            :disabled="column.disabled"
            @change="Replace(column.id, column.columncontent)"
          ></el-input>
          <el-button @click="delColumn(column.id)">X</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          id: 0,
          columnname: "",
          parentcolumn: "",
          columncate: "",
          columnrequired: "",
          columncontent: "",
          disabled: false,
          isparent: false,
        },
      ],
      columns_num: 0,
      parents: [],
      cates: ["Text", "Dropdown List", "Date"],
      isrequired: ["Required", "Not required", "Custom"],
    };
  },
  methods: {
    addColumn() {
      this.columns_num++;
      var oo = {
        id: this.columns_num,
        columnname: "",
        parentcolumn: "",
        columncate: "",
        columnrequired: "",
        columncontent: "",
      };
      this.columns.push(oo);
    },
    delColumn(columnid) {
      var oo = this.columns.find((p) => p.id == columnid);
      var index = this.columns.indexOf(oo);
      this.columns.splice(index, 1);
    },
    getParents(id) {
      this.parents = [];
      this.columns.forEach((p) => {
        if (p.columnname + "" != "" && p.id != id) {
          this.parents.push(p.columnname);
        }
      });
    },
    disclick(ID, value) {
      var oo = this.columns.find((p) => p.id == ID);
      if (value != "Dropdown List") {
        oo.columncontent = "";
        oo.disabled = true;
      } else {
        oo.disabled = false;
      }
    },
    Replace(id, content) {
      content = content.replace("，", ",");
      content = content.replace("；", ",");
      content = content.replace(";", ",");
      var oo = this.columns.find((p) => p.id == id);
      oo.columncontent = content;
      console.log(this.columns);
    },
    parentChange(id) {
      debugger;
      var oo = this.columns.find((p) => p.id == id);
      if (oo.parentcolumn + "" != "") {
        oo.isparent = true;
      } else {
        oo.isparent = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content_title {
  margin: auto;
  width: 1200px;
  margin-top: 10px;
  text-align: left;

  .input-search {
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 10px;
    width: 300px;
  }
  .input-filter {
    margin-top: 10px;
    width: 300px;
  }
  .button-search {
    background-color: #e6a23c;
    border: 0px #e6a23c;
    color: #ffff;
    margin-top: 10px;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Temp.vue